import { render, staticRenderFns } from "./EventWizardBase.vue?vue&type=template&id=06bc8d28&"
import script from "./EventWizardBase.vue?vue&type=script&lang=js&"
export * from "./EventWizardBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports